/**
 * Sleeper Supplement Utility Functions
 */

// Check cabin type by description
const hasCabinType = (supplement, type) => {
	const desc = supplement.description?.toLowerCase() || '';
	return desc.includes(type);
};

// Single cabin
export const isSingleCabin = (supplement) => hasCabinType(supplement, 'single');

// Twin cabin
export const isTwinCabin = (supplement) => hasCabinType(supplement, 'twin');

// Filter supplements to show based on passenger count
export const getCheapestSupplements = (supplementsList, passengerNumber) => {
	if (passengerNumber === 1) {
		// For 1 passenger: Just the cheapest option
		return supplementsList.slice(0, 1);
	}

	// For 2+ passengers: Cheapest single AND cheapest twin
	const singleCabins = supplementsList.filter(isSingleCabin);
	const twinCabins = supplementsList.filter(isTwinCabin);

	const result = [];
	if (singleCabins.length > 0) result.push(singleCabins[0]);
	if (twinCabins.length > 0) result.push(twinCabins[0]);

	return result;
};

// Group supplements by travel segment ID
export const groupSelectionsBySegment = (supplements) => {
	const grouped = {};
	supplements.forEach((supplement) => {
		supplement.linkedTravelSegments?.forEach((segmentId) => {
			if (!grouped[segmentId]) {
				grouped[segmentId] = [];
			}
			grouped[segmentId].push(supplement);
		});
	});
	return grouped;
};

// Check if two supplements match by passenger and segment
export const matchesPassengerAndSegment = (
	supplement,
	targetSupplement,
	travelSegmentId,
) => {
	const samePassenger =
		supplement.linkedPassengers[0] === targetSupplement.linkedPassengers[0];
	const sameSegment = supplement.linkedTravelSegments.includes(travelSegmentId);
	return samePassenger && sameSegment;
};

// Check if two supplements are the same supplement (by ID)
export const isSameSupplement = (supplement, targetSupplement) =>
	supplement.id === targetSupplement.id ||
	supplement.originalId === targetSupplement.originalId;

/**
 * Check if connecting doors should be auto-unchecked
 * - For 2 passengers: Must have exactly 2 singles selected
 * - For 3+ passengers: Always allowed (never auto-uncheck)
 * - For 1 passenger: N/A (checkbox never shown)
 */
export const shouldAutoUncheckConnectingDoors = (
	passengerNumber,
	selections,
) => {
	// Only apply auto-uncheck logic for 2 passengers
	if (passengerNumber !== 2) {
		return false;
	}

	// Must have exactly 2 singles selected
	const bothAreSingles =
		selections.length === 2 && selections.every(isSingleCabin);

	return !bothAreSingles;
};
